import React, { useEffect, useState } from "react";
import {
	Form,
	Button,
	Popconfirm,
	message,
	Modal,
	Spin,
	Table,
	Input,
} from "antd";
import {
	useGetPickupLocationQuery,
	useAddPickupLocationMutation,
	useDeletePickupLocationMutation,
	useUpdatePickupLocationMutation,
} from "@/redux/services/pickupApi";

const Add = () => {
	const [form] = Form.useForm();
	const [isOpen, setIsOpen] = useState(false);

	const [addPickupLocation] = useAddPickupLocationMutation();
	const { refetch } = useGetPickupLocationQuery();

	const onFinish = async (values) => {
		await addPickupLocation({
			...values,
		})
			.unwrap()
			.then((payload) => {
				refetch();
				form.resetFields();
				setIsOpen(false);
				message.success("Create successful");
			})
			.catch((error) => message.error("Something went wrong..."));
	};

	const handleCancel = () => {
		form.resetFields();
		setIsOpen(false);
	};

	return (
		<div>
			<Button
				style={{ marginBottom: "30px" }}
				onClick={() => setIsOpen(true)}
			>
				新接送点
			</Button>
			<Modal
				title="Create A Pickup Location"
				open={isOpen}
				onCancel={handleCancel}
				footer={[
					<Button key="cancel" onClick={handleCancel}>
						Cancel
					</Button>,
				]}
				width="60%"
			>
				<Form
					form={form}
					onFinish={onFinish}
					labelCol={{ span: 8 }}
					wrapperCol={{ span: 16 }}
					style={{ maxWidth: 600, marginTop: "30px" }}
				>
					<Form.Item
						name="location_name"
						label="名字"
						rules={[{ required: true, message: "请输入名字" }]}
					>
						<Input />
					</Form.Item>
					<Form.Item
						name="location_address"
						label="地址"
						rules={[{ required: true, message: "请输入地址" }]}
					>
						<Input />
					</Form.Item>

					<Form.Item wrapperCol={{ offset: 8, span: 16 }}>
						<Button type="primary" htmlType="submit">
							Submit
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</div>
	);
};

const Edit = ({ item, isOpen, handleClose }) => {
	const [form] = Form.useForm();
	const [updatePickupLocation] = useUpdatePickupLocationMutation();

	const handleCancel = () => {
		handleClose();
	};

	const onFinish = async (values) => {
		try {
			await updatePickupLocation({
				...values,
				location_id: item.location_id,
			});
			message.success("Update successful");
			handleCancel();
		} catch (error) {
			message.error("Something went wrong...");
		}
		// await updateDriver({
		// 	...values,
		// 	user_detail_id: item.user_detail_id,
		// })
		// 	.unwrap()
		// 	.then((payload) => {
		// 		message.success("Update successful");
		// 		handleCancel();
		// 	})
		// 	.catch((error) => message.error("Something went wrong..."));
	};

	useEffect(() => {
		form.setFieldsValue(item); // 确保每次 item 更新时，更新表单的字段值
	}, [form, item]);

	return (
		<div>
			<Modal
				title="Edit Pickup Location"
				open={isOpen}
				onCancel={handleCancel}
				footer={[
					<Button key="cancel" onClick={handleCancel}>
						Cancel
					</Button>,
				]}
				width="60%"
			>
				<Form
					form={form}
					onFinish={onFinish}
					labelCol={{ span: 8 }}
					wrapperCol={{ span: 16 }}
					style={{ maxWidth: 600, marginTop: "30px" }}
					initialValues={item}
				>
					<Form.Item
						name="location_name"
						label="名字"
						rules={[{ required: true, message: "请输入名字" }]}
					>
						<Input disabled />
					</Form.Item>
					<Form.Item
						name="location_address"
						label="地址"
						rules={[{ required: true, message: "请输入地址" }]}
					>
						<Input />
					</Form.Item>

					<Form.Item wrapperCol={{ offset: 8, span: 16 }}>
						<Button type="primary" htmlType="submit">
							Submit
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</div>
	);
};

const PickupLocatioin = () => {
	const { data, isLoading, isError, refetch } = useGetPickupLocationQuery();
	const [deletePickupLocation] = useDeletePickupLocationMutation();
	const [isOpenEdit, setIsOpenEdit] = useState(false);
	const [editItem, setEditItem] = useState();

	const handleClose = async () => {
		await refetch();
		setIsOpenEdit(false);
		setEditItem(undefined);
	};

	const handleDelete = async (item) => {
		try {
			await deletePickupLocation(item.location_id);
			message.success(`${item.location_name} delete successful!`);
			refetch();
		} catch (error) {
			message.error("something went wrong");
			console.log("error", error);
		}

		// await deleteDriver(item.user_detail_id)
		// 	.unwrap()
		// 	.then((payload) => {
		// 		message.success("delete successful");
		// 		refetch();
		// 	})
		// 	.catch((error) => message.error("Something went wrong..."));
	};

	const columns = [
		{
			title: "名字",
			dataIndex: "location_name",
			key: "location_name",
			editable: true,
		},
		{
			title: "地址",
			dataIndex: "location_address",
			key: "location_address",
			editable: true,
		},
		{
			title: "修改",
			dataIndex: "",
			key: "x",
			render: (item) => {
				return (
					<Button
						onClick={() => {
							setIsOpenEdit(true);
							setEditItem(item);
						}}
					>
						Edit
					</Button>
				);
			},
		},
		{
			title: "删除",
			dataIndex: "",
			key: "x",
			render: (item) => {
				return (
					<Popconfirm
						title="Delete the location"
						description="Are you sure to delete this location?"
						onConfirm={() => handleDelete(item)}
						okText="Yes"
						cancelText="No"
					>
						<Button danger>Delete</Button>
					</Popconfirm>
				);
			},
		},
	];

	if (isLoading) {
		return <Spin />;
	}

	if (isError) {
		return <div>something went wrong</div>;
	}
	return (
		<div>
			<Add />
			<Table dataSource={data} columns={columns} />
			<Edit
				handleClose={handleClose}
				isOpen={isOpenEdit}
				item={editItem}
			/>
		</div>
	);
};

export default PickupLocatioin;
